import { render, staticRenderFns } from "./ConfigAlertGoogleChat.vue?vue&type=template&id=44850012&scoped=true"
import script from "./ConfigAlertGoogleChat.vue?vue&type=script&lang=js"
export * from "./ConfigAlertGoogleChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44850012",
  null
  
)

export default component.exports